module.exports = __webpack_public_path__ + "static/img/y_szzc54.be0c9d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_szzc54.png
// module id = q4CR
// module chunks = 73